import request from '@/utils/request';

export async function incomeStatementReport(params: any) {
  return request.get(`/accounting/income-statement-report`, {
    data: params,
  });
}
